import TaskCard from "../../tasks/taskCard";
import Lang from "../../../userPreferences/staticWords";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCommunityTaskForm,
  getTaskSearch,
  searchAllTasks,
  searchKey,
  SubTaskDataAdd,
} from "../../../API/store/actions/tasks";
import { customStyle, styleEnd } from "../../../algorithms/styleDirection";
import Titlebar from "../../layout/titlebar";
import Paginate from "../../layout/paginate";
import {
  englishDate,
  ScrollToTop,
  setCurrentPageandResetData,
} from "../../../algorithms";
import TextInput from "../../sharedComponents/inputs/textInput";
import { styleStart } from "../../../algorithms/styleDirection";
import { useParams } from "react-router-dom";
import CardWithTitleAndIcon from "../../reusableComponents/cardWithTitleButton";
import DropDownList from "../../sharedComponents/dropdown/dropdown";
import DateInput from "../../sharedComponents/datesInputs/date";
import StatusSection from "../../reusableComponents/statusSection";
import Slide from "react-reveal/Slide";
import { resolver } from "../../../API/middlewares/resolveRequests";
import LoadingPopup from "../../layout/loadingPopup";
import { searchAllTaskStatusCount } from "../../../API/store/actions/tasks";
import Select from "react-select";
import BackIcon from "../../BackIcon/BackIcon";

const EntityProcedures = ({ userToken }) => {
  const [show, setShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [procAdded, setProcAdded] = useState(false);
  const param = useParams();
  const searchkey = useSelector((state) => state.tasks.searchkey);
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const memberId = param.userId;
  const userId = memberId?.split("&")[0];
  const userName = memberId?.split("&")[1];
  const routingCommunity = param.communityId;
  const routingCommunityId = routingCommunity?.split("&")[0];
  const routingCommunityName = routingCommunity?.split("&")[1];

  const { taskStatusId } = param;

  const onShow = () => {
    setShow(true);
  };
  const communityId = 0; //useSelector((state) => state.community.communityId?.id);
  const reload = useSelector((state) => state.reload.reload);
  const community = useSelector((state) => state.community.communityId);

  const dispatch = useDispatch();
  const TasksWithProcedures = useSelector(
    (state) => state.tasks.getAllTasksWithProcedures,
  );

  const communityTaskForm = useSelector(
    (state) => state.tasks.getCommunityTaskForm,
  );

  const tasksCount = useSelector((state) => state.tasks.getAllTasksCount);

  const [AdminTaskMembersList, setAdminTaskMembersList] = useState([]);
  const [TaskMembersList, setTaskMembersList] = useState([]);

  const [TaskStatusDropdownList, setTaskStatusDropdownList] = useState([]);
  const [PriorityDropdownList, setPriorityDropdownList] = useState([]);

  const [createContent, setCreateContent] = useState();
  const [searchText, setSearchText] = useState(searchkey);
  const [prioritySearch, setPrioritySearch] = useState(null);
  const [taskStatusSearch, setTaskStatusSearch] = useState(
    (userId && userId != "index") || routingCommunityId
      ? 0
      : (taskStatusId ?? null),
  );
  const [accessLevel, setAccessLevel] = useState();
  const [membersSearch, setMembersSearch] = useState(
    userId != "index" ? userId : null,
  );
  //   const [communitySearch, setCommunitySearch] = useState(
  //     routingCommunityId ?? null
  //   )
  const [communitySearch, setCommunitySearch] = useState(param?.axisId);
  const [classificationId, setClassificationId] = useState(0);
  useEffect(() => {
    dispatch(getCommunityTaskForm(communityId, userToken));
    dispatch(
      searchAllTasks(
        communitySearch ? communitySearch : 0,
        currentPage,
        20,
        {
          name: searchText,
          memberId: param?.id,
          priorityId: prioritySearch
            ? prioritySearch == 0
              ? null
              : prioritySearch
            : null,
          taskStatusId: taskStatusSearch == 0 ? null : taskStatusSearch,
          startDate: StartDate ? englishDate(StartDate) : null,
          endDate: EndDate ? englishDate(EndDate) : null,
          accessLevelId: accessLevel == 0 ? null : accessLevel,
          classification: classificationId,
        },
        userToken,
      ),
    );

    ScrollToTop();
  }, [currentPage, param?.id, communitySearch]);

  const [searchDropdowns, setSearchDrobdowns] = useState({});
  useEffect(() => {
    resolver(getTaskSearch, setSearchDrobdowns, communityId, userToken);
  }, [communityId]);
  let priorityList = [];
  let taskStatusList = [];
  let membersList = [];
  let communitiesList = [];
  let accesslevelList = [];
  const [showSearch, setShowSearch] = useState(false);
  if (searchDropdowns?.data?.taskStatusLkp) {
    taskStatusList = searchDropdowns?.data?.taskStatusLkp.map((item) => ({
      value: item.id,
      label: item.name,
    }));
    taskStatusList.unshift({ value: 0, label: "الكل" });
  }
  if (searchDropdowns?.data?.accesslevelLkp) {
    accesslevelList = searchDropdowns?.data?.accesslevelLkp.map((item) => ({
      value: item.id,
      label: item.name,
    }));
    accesslevelList.unshift({ value: 0, label: "الكل" });
  }
  if (searchDropdowns?.data?.priorityLkp) {
    priorityList = searchDropdowns?.data?.priorityLkp.map((item) => ({
      value: item.id,
      label: item.name,
    }));
    priorityList.unshift({ value: 0, label: "الكل" });
  }
  if (searchDropdowns?.data?.members) {
    membersList = searchDropdowns?.data?.members.map((item) => ({
      value: item.memberId,
      label: item.memberName,
    }));
    membersList.unshift({ value: 0, label: "الكل" });
  }
  if (searchDropdowns?.data?.communities) {
    communitiesList = searchDropdowns?.data?.communities.map((item) => ({
      value: item.id,
      label: item.name,
    }));
    communitiesList.unshift({ value: 0, label: "الكل" });
  }

  if (searchDropdowns?.data && taskStatusList?.length > 1)
    return (
      <div className="d-flex flex-column w-100">
        <div
          className="ctr"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            margin: "0 20px",
            position: "relative",
            zIndex: "10",
          }}
        >
          <BackIcon />
        </div>
        {/* title */}
        <Titlebar
          title={
            Lang.tasksNavTab +
            " " +
            (userId != "index" && !taskStatusSearch
              ? routingCommunityName
                ? "التابعة الى  : " + routingCommunityName
                : "التابعة الى  : " + param?.name
              : "")
          }
          customImage={"/assets/images/icon1.svg"}
        />

        <div
          className={`d-lg-flex d-none col justify-content-end my-2 my-md-0 ${customStyle(
            "filterIcon",
          )}`}
          style={{ zIndex: 10 }}
          title={"بحث"}
        >
          <div
            className={`mx-2 d-flex justify-content-center align-items-center ${
              showSearch == true ? "backgroundEffect" : "bg-white"
            }`}
            style={{
              border: "1px solid rgba(199, 199, 201, 1)",
              borderRadius: "50%",
              height: 40,
              width: 40,
              cursor: "pointer",
            }}
            onClick={() => {
              setShowSearch(!showSearch);
            }}
          >
            <img
              className={`${showSearch == true ? "filterEffect" : ""}`}
              src="/assets/images/filter.svg"
              width={20}
              height={20}
              alt=""
            />
          </div>
        </div>

        {/* search Input Start */}
        {showSearch && (
          <Slide left opposite collapse when={showSearch}>
            <div
              className={`d-flex flex-column ${styleStart(
                "p",
                4,
                "md",
              )} justify-content-center justify-content-lg-start align-items-center align-items-lg-start mt-3 align-items-center`}
            >
              <div className="d-flex flex-lg-row flex-column col-lg-8 col-10"></div>
              <div className="d-flex flex-lg-row justify-content-start col-10 col-lg-8 flex-column px-0">
                <div
                  style={{ height: "1.5rem", zIndex: "101" }}
                  className={`col-12 mb-3 mb-lg-0 col-lg-3 mt-2 besideDate ${styleEnd(
                    "p",
                    2,
                    "lg",
                  )}`}
                >
                  <Select
                    value={{
                      value: communitiesList?.find(
                        (el) => el?.value == communitySearch,
                      )?.value,
                      label: communitiesList?.find(
                        (el) => el?.value == communitySearch,
                      )?.label,
                    }}
                    onChange={(e) => {
                      setCurrentPage(1);
                      setCommunitySearch(parseInt(e.value));
                    }}
                    placeholder={"المحاور"}
                    options={communitiesList}
                  />
                </div>
              </div>
            </div>
          </Slide>
        )}
        {searchkey ? (
          <div
            className={`d-flex ${styleStart(
              "p",
              5,
              "md",
            )} justify-content-center justify-content-lg-start mt-3 align-items-center `}
          >
            <span className=" fw-bold">نتائج البحث عن</span>: {searchkey}{" "}
          </div>
        ) : null}
        {/* search Input End */}

        {/* Cards Listing Start */}
        <div className="d-flex flex-lg-row flex-column-reverse flex-wrap align-items-center">
          {/* Task Card */}
          <TaskCard
            currentPage={currentPage}
            communityId={communityId}
            userToken={userToken}
            TasksWithProcedures={TasksWithProcedures}
            communityTaskForm={communityTaskForm}
            setProcAdded={setProcAdded}
            procAdded={procAdded}
          />

          {/* lg screens button */}
        </div>
        {/* Cards Listing End */}
        {/* pagination */}
        {TasksWithProcedures?.count > 0 ? (
          <div className="my-3 d-flex justify-content-center col-lg-8">
            <Paginate
              pageCount={Math.ceil(TasksWithProcedures?.count / 20)}
              currentPage={currentPage}
              clearData={undefined}
              setCurrentPage={setCurrentPage}
              setCurrentPageandResetData={setCurrentPageandResetData}
            />
          </div>
        ) : (
          <p className="m-5">لا يوجد نتائج</p>
        )}
        {/* end agination */}
      </div>
    );
  return <LoadingPopup show={true} />;
};
export default EntityProcedures;
